import React from 'react';
import {connect} from 'react-redux';

import * as commonApi from '../../api/common-api';
import {isMobile} from 'react-device-detect';
import Loading from 'react-loading';
import axios from 'axios';
import Waypoint from 'react-waypoint';

import ReactGA from 'react-ga';

import {IndexLink, Link, withRouter} from 'react-router';

import Splash_Signin from '../commons/splash_signin';
import Footer2Component from '../commons/footer2';
import CoursePostsFeeds from '../../appcomponents/commons/course/course_posts_feeds';
import POPUP from '../../appcomponents/commons/popup';
import LoginPopup from "../../appcomponents/commons/LoginPopup";

const customStyles2 = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: '999',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        position: 'relative',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        margin: '0',
        padding: '80px 0px',
        width: '600px',
        height: '380px',
        minHeight: '300px',
        zIndex: '999',
        textAlign: 'center'
    }
};

class CompanyPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.handleFeedCallback = this.handleFeedCallback.bind(this);

        var compId = this.props.params.compId;

        this.state = {
            compId: compId,
            itemArr2: [],
            items2: [],
            start2: 0,
            feeds: [],
            start: 0,
            total: 0,
            load_done: false
        };
    }

    componentDidMount() {
        this.getCompany();
        this.getSiteJobs();
    }

    onCloseLoginPopover() {
        this.setState({showLoginPopover: false});
    }

    viewLoginPopover(e) {
        this.setState({showLoginPopover: true});
    }

    getSiteJobs = () => {
        this.setState({loading: true});
        var url = "/code/apis.php?api=getSiteJobs";
        var data = new FormData();

        data.append("company", this.state.compId);
        data.append("start", this.state.start2);
        axios.post(url, data)
            .then(response => {
                if (response.data.status == 1) {
                    var start2 = this.state.start2;
                    start2 += response.data.data.length;
                    var itemArr2 = this.state.itemArr2;
                    //var end = response.data.end;

                    var city = "";
                    for (var item of response.data.data) {
                        if (city == "") {
                            city = item.location_job;
                        }
                        var name = item.name_company.substring(0, 1);

                        if (item.file != undefined) {
                            name = (<img src={item.file.link_file}/>);
                        } else {
                            name = (<div className="c_logo">{name}</div>);
                        }
                        itemArr2.push(<div className="job_item" key={"jobsite-item-" + item.id_job}>
                            <a href={"/jobsitedetail/" + item.id_job} target="_blank">
                                <div className="clickable">
                                    <div className="job_item_left">
                                        <div className="item_logo_w">
                                            <div className="item_logo">
                                                {name}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="job_item_right">
                                        <div className="item_title">
                                            {item.title_job}
                                        </div>
                                        <div className="item_com">
                                            {item.name_company}
                                        </div>
                                        <div className="item_detail_container">
                                            <b>{item.type_job} {item.industry_job}</b> opportunity in
                                            the <b>{item.func_job}</b> industry
                                            <div className="item_detail"
                                                 dangerouslySetInnerHTML={{__html: item.des_job}}/>
                                        </div>
                                        {
                                            item.location_job
                                            && <div className="item_location">
                                                {item.location_job}&nbsp;&minus;&nbsp;
                                            </div>
                                        }
                                        {
                                            item.time_job
                                            && <div className="item_time">
                                                Application Deadline: {this._parseDate(item.exp_job)}
                                            </div>
                                        }
                                    </div>

                                </div>
                            </a>

                            <a className="btn_v btn_cancel apply2" href={item.url_job} target="_blank">APPLY ON SITE</a>

                        </div>);
                    }
                }

                this.setState({loading: false});
                return response;
            }).catch(error => {
            this.setState({loading: false});
        });
    }

    getCompany = () => {
        axios.get(commonApi.getAPIURL() + '?api=getCompanyView&comp_id=' + this.state.compId)
            .then(response => {
                if (response.data.status == 1) {

                    this.setState({company: response.data.data});
                }
                return response;
            });
    }

    componentWillReceiveProps(nextProps) {
        var load = false;
        if (this.state.compId != nextProps.params.compId) {
            load = true;
        }
        if (load) {
            this.setState({compId: nextProps.params.compId}, () => {
                this.getCompany();
                this.getFeed2();
            });
        } else {
            this.setState({compId: nextProps.params.compId});
        }

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    follow() {
        axios.get(commonApi.getAPIURL() + '?api=followCompany&id_company=' + this.state.compId)
            .then(response => {
                if (response.data.status == 1) {
                    this.getCompany();
                }
                return response;
            });
    }

    unfollow() {
        axios.get(commonApi.getAPIURL() + '?api=unfollowCompany&id_company=' + this.state.compId)
            .then(response => {
                if (response.data.status == 1) {
                    this.getCompany();
                }
                return response;
            });
    }

    handleFeedCallback(feed, type = "update") {

        var feedsList = this.state.feeds;
        for (var i = 0; i < feedsList.length; i++) {
            if (feedsList[i].id_feed == feed.id_feed) {

                if (type == "delete") {
                    feedsList.splice(i, 1);
                } else {
                    feedsList[i] = feed;
                }
                this.setState(Object.assign(this.state, {feeds: feedsList}));
                break;
            }
        }
    }

    getHomeFeed() {
        this.setState({loading: true});
        var data = new FormData();
        data.append("start", this.state.start);
        data.append("id_company", this.state.compId);
        axios.post('/code/api_feeds.php?api=getFeedsHome', data)
            .then(response => {
                var feeds = this.state.feeds;
                if (response.data.status == 1) {

                    this.setState(Object.assign(this.state, {
                        feeds: feeds.concat(response.data.data),
                        loading: false,
                        load_done: true,
                        total: response.data.total
                    }));
                } else {
                    this.setState({loading: false});
                }
                return response;
            });
    }

    _handleWaypointEnter() {
        this.setState({start: this.state.feeds.length}, () => {
            this.getHomeFeed();
        });
    }

    handleClickSee = (event) => {
        const seeMore = this.state.seeMore?false:true;
        this.setState({seeMore: seeMore});
    }

    render() {
        if (this.state.company == undefined) {
            return (
                <div className="app_page_wrapper">
                    <div>
                        <div className="center_div"><Loading type='spinningBubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>
                    </div>
                </div>
            );
        }
        var avatar = this.state.company.name_company.substring(0, 1).toUpperCase();
        var avatar_circle = <span>{this.state.company.name_company.substring(0, 1).toUpperCase()}</span>;
        if (this.state.company.id_file_company != 0) {
            avatar = this.state.company.file.link_file;
            avatar_circle = (<img className="img_circle" src={this.state.company.file.link_file} alt=""/>);
        }
        var social = [];
        if (this.state.company.fb_company != "") {
            social.push(<a key="comp-fb" href={this.state.company.fb_company} target="_blank">
                <img alt=""
                     src="/static/img/homeimg/splash-social-fb.png"
                     style={{
                         height: "21px",
                         width: "auto",
                         marginRight: "5px"
                     }}/></a>)
        }
        if (this.state.company.tw_company != "") {
            social.push(<a key="comp-tw" href={this.state.company.tw_company} target="_blank">
                <img alt=""
                     src="/static/img/homeimg/splash-social-tt.png"
                     style={{
                         height: "21px",
                         width: "auto",
                         marginRight: "5px"
                     }}/></a>)
        }
        if (this.state.company.in_company != "") {
            social.push(<a key="comp-in" href={this.state.company.in_company} target="_blank">
                <img alt=""
                     src="/static/img/appimg/Linkedin_logo.png"
                     style={{
                         height: "21px",
                         width: "auto",
                         marginRight: "5px"
                     }}/></a>)
        }
        var slist = [];
        if (this.state.company.slist != undefined && Object.keys(this.state.company.slist).length > 0) {
            for (var user of this.state.company.slist) {
                slist.push(<img key={"slist-" + user.id_account} className="img_circle_s slist_item"
                                src={user.link_thumb_file} alt=""/>);
            }
            if (this.state.company.count - this.state.company.slist.length > 0) {
                slist.push(<span key="slist-more" className="slist_item slist_more"
                                 alt="">+{this.state.company.count - this.state.company.slist.length}</span>);
            }
        }
        var follow_div = "";
        var follow_btn = "";
        var follow = "0 follower";
        if (this.state.company.follow == 1) {
            follow = "1 follower";
        }
        if (this.state.company.follow > 1) {
            follow = this.state.company.follow + " followers";
        }
        if (this.state.company.is_follow == 0) {
            follow_div = (<div className="follow pt3">
                <button onClick={this.follow.bind(this)}
                        className="follow ember-view org-company-follow-button org-top-card-primary-actions__action artdeco-button">
                    <li-icon aria-hidden="true" type="plus-icon"
                             className="artdeco-button__icon" size="small">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 16 16" data-supported-dps="16x16"
                             fill="currentColor" className="mercado-match"
                             width="16" height="16" focusable="false">
                            <path d="M14 9H9v5H7V9H2V7h5V2h2v5h5z"></path>
                        </svg>
                    </li-icon>
                    <span aria-hidden="true">Follow</span>
                </button> {follow}</div>);
            follow_btn = (
                <button onClick={this.follow.bind(this)}
                        className="follow ember-view org-company-follow-button org-top-card-primary-actions__action artdeco-button fr">
                    <li-icon aria-hidden="true" type="plus-icon"
                             className="artdeco-button__icon" size="small">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 16 16" data-supported-dps="16x16"
                             fill="currentColor" className="mercado-match"
                             width="16" height="16" focusable="false">
                            <path d="M14 9H9v5H7V9H2V7h5V2h2v5h5z"></path>
                        </svg>
                    </li-icon>
                    <span aria-hidden="true">Follow</span>
                </button>
            );
        } else {
            follow_div = (<div className="follow pt3">
                <button onClick={this.unfollow.bind(this)}
                        className="follow ember-view org-company-follow-button org-top-card-primary-actions__action artdeco-button">
                    <li-icon aria-hidden="true" type="plus-icon"
                             className="artdeco-button__icon" size="small">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 16 16" data-supported-dps="16x16"
                             fill="currentColor" className="mercado-match"
                             width="16" height="16" focusable="false">
                            <path d="M14 9H9v5H7V9H2V7h5V2h2v5h5z"></path>
                        </svg>
                    </li-icon>
                    <span aria-hidden="true">Unfollow</span>
                </button> {follow}</div>);
            follow_btn = (
                <button onClick={this.unfollow.bind(this)}
                        className="follow ember-view org-company-follow-button org-top-card-primary-actions__action artdeco-button fr">
                    <li-icon aria-hidden="true" type="plus-icon"
                             className="artdeco-button__icon" size="small">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 16 16" data-supported-dps="16x16"
                             fill="currentColor" className="mercado-match"
                             width="16" height="16" focusable="false">
                            <path d="M14 9H9v5H7V9H2V7h5V2h2v5h5z"></path>
                        </svg>
                    </li-icon>
                    <span aria-hidden="true">Unfollow</span>
                </button>
            );
        }
        let bg_outside_url = (this.state.company.id_banner_file_company == 0 || this.state.company.id_banner_file_company == "0")
            ? '/static/img/appimg/default-banner.png'
            : this.state.company.bfile.link_file;

        if (isMobile) {
            bg_outside_url = 'url(' + bg_outside_url + ')';
            
            return (
                <div id={"response-profile-mobile"}>
                    <header>
                        <div className="header">
                            <div className="splash_logo">
                                <Link to="/"><img alt="VERSITY" src="/static/img/appimg/login_h_logo.png"/></Link>
                            </div>
                            <div className={"sign-in"}>
                                <span><Link to="/signin" className={"btn-white"}>Sign in</Link></span>
                                <Link to="/signup" className={"btn"}>Join now</Link>
                            </div>
                        </div>
                    </header>
                    <div className={"pf_outside_wrapper"}>
                        <div id={"pf_company"} className="bg_outside public_company" style={{backgroundImage: bg_outside_url}}>
                            <div className="pf_header">
                                <div className="pf_logo">
                                    {avatar.length == 1 ? (<a className="img_nocircle_wrapper" style={{
                                        backgroundColor: "#8c8c8c",
                                        color: "white",
                                        textAlign: "center",
                                        lineHeight: "140px",
                                        fontSize: "60pt"
                                    }}>{avatar}</a>) : (<a className="img_nocircle_wrapper" style={{color: "white"}}>{avatar}</a>)}
                                </div>
                                <div className="pf_title">
                                    <div>
                                        <h2><p className={'t-24'}>{this.state.company.name_company}</p></h2>
                                        <p className={'t-14'}>{this.state.company.cat_company}</p>
                                        <p className={"t-14"}> {this.state.company.city_company}</p>
                                        {follow_div}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"pf-feeds"}>
                            <div className={"about-us-wrap"}>
                                <div className={"about-us"}>
                                    <span className={'t-18'}>About Us</span>
                                    <div className="row_box_right t-14 w-auto org-page-details__definition-text" dangerouslySetInnerHTML={{__html: this.state.company.des_company}}></div>

                                    <div className={this.state.seeMore?'':'hide-el'}>
                                        <span className={"pf_ab_tiltle"}>Website</span>
                                        <p>{this.state.company.web_company}</p>

                                        <span className={"pf_ab_tiltle"}>Headquarters</span>
                                        <p>{this.state.company.city_company}</p>

                                        <span className={"pf_ab_tiltle"}>Founded</span>
                                        <p>{this.state.company.founded_company}</p>

                                        <span className={"pf_ab_tiltle"}>Employees</span>
                                        <p>{this.state.company.emp_company}</p>

                                        <span className={"pf_ab_tiltle"}>Categories</span>
                                        <p>{this.state.company.cat_company}</p>
                                    </div>
                                </div>
                                <div className={"btn_see"} onClick={this.handleClickSee.bind(this)}>
                                    {this.state.seeMore?
                                        <span>See less <p className="glyphicon glyphicon-menu-up" aria-hidden="true"></p></span>
                                        :<span>See more <p className="glyphicon glyphicon-menu-down" aria-hidden="true"></p></span>
                                    }
                                </div>
                            </div>
                            <div className={"recent-update"}>Recent Updates:</div>
                            {this.state.feeds.length > 0 ?
                                <div className={"col-md-8"}>
                                    <CoursePostsFeeds key="normal_feed" detail={1} user={0} courseId={0}
                                                      feeds={this.state.feeds}
                                                      isMobile={1}
                                                      handleFeedCallback={this.handleFeedCallback}/>
                                    {this.state.loading?(<div className="center_div"><Loading type='bubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>):""}
                                </div>:""
                            }
                        </div>
                    </div>
                    <Waypoint
                        bottomOffset={-20}
                        onEnter={this._handleWaypointEnter.bind(this)}
                    />
                    <div className={"footerClear"}>&nbsp;</div>
                    <Footer2Component/>
                    <POPUP style={customStyles2} show={this.state.showLoginPopover} onClose={this.onCloseLoginPopover.bind(this)} content={( <LoginPopup msg={"follow this company"} onClose={this.onCloseLoginPopover.bind(this)} />)} />
                </div>
            )
        }

        return (
            <div>
                <div id="company">
                    <header>
                        <div className="header">
                            <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                            <Splash_Signin type="0" url="/code/apis.php"/>
                        </div>
                    </header>
                    <div className="splash_wrapper"></div>
                </div>
			    <div id="content" className="no-marging-top">
				<div className="container section-company-detail" id="root-linkedin">
					<div className="scaffold-layout__row scaffold-layout__content scaffold-layout__content--main">
						<main id="main" className="scaffold-layout__main">
							<div>
								<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
									className="hidden" data-elementtiming="true" alt="" role="none"/>
								<section id="ember3348" className="artdeco-card ember-view pv-top-card">
									<div className="live-video-hero-image"
										 style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
										<div tabIndex="0" aria-label="Profile background"
											 className="profile-background-image">
											<div className="profile-background-image__image-container">
												<img
													className="profile-background-image__image relative full-width full-height"
													id="profile-background-image-target-image"
													alt="Background Image"
													src={bg_outside_url}
												/>
											</div>
										</div>
									</div>

									<div className="ph5 pb5">
										<div className="display-flex pv-top-card--reflow">
											<div className="pv-top-card--photo text-align-left">
												<div className="pv-top-card__photo-wrapper ml0">
													<div className="presence-entity presence-entity--size-9 pv-top-card__image">
														{parseInt(avatar.length) === 1 ?
															<span>{avatar}</span>
															:
															<img title="Avatar"
																 src={avatar}
																 className="presence-entity__image  pv-top-card__photo  lazy-image ghost-person ember-view"/>
														}
													</div>
												</div>
											</div>
										</div>

                                        <div className="pt3">
                                            <div className="org-top-card__primary-content org-top-card-primary-content--zero-height-logo org-top-card__primary-content--ia">
                                                <div className="block mt2">
                                                    <div>
                                                        <h1 className="org-top-card-summary__title t-24 t-black t-bold truncate" title="Microsoft On the Issues">
                                                            <span dir="ltr">{this.state.company.name_company}</span>
                                                        </h1>
                                                        <p className="org-top-card-summary__tagline t-16 t-black">
                                                            {this.state.company.cat_company} · {this.state.company.city_company}
                                                        </p>
                                                        <div className="org-top-card-summary-info-list t-14 t-black--light">
                                                            <div className="inline-block">
                                                                <div className="org-top-card-summary-info-list__info-item">
                                                                    {slist.length > 0 ? (
                                                                        <div className="slist">
                                                                            {slist}
                                                                            <span>{this.state.company.count > 0 ? this.state.company.count + " people from your school were hired here" : ""}</span>
                                                                        </div>
                                                                    ) : ""}
                                                                    {follow_div}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
									</div>
								</section>
							</div>
							<div className="scaffold-layout--static">
								<div className="scaffold-layout__content scaffold-layout__content--main-aside">
									<main id="sub-main" className="scaffold-layout__main">
										<div className="pv-oc ember-view mb3">
											<section id="ember3482" className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
												<div label="About" value={0} className={"tab_item"}>
													<div className="company_content_wrapper pd0">
														<h4 className="pv-profile-section__card-heading mgt00">Overview</h4>
														<div className="row_box">
															<div className="row_box_left">
																Headquarters:
															</div>
															<div className="row_box_right">
																{this.state.company.city_company}
															</div>
														</div>
														<div className="row_box">
															<div className="row_box_left">
																Description:
															</div>
															<div className="row_box_right"
																 dangerouslySetInnerHTML={{__html: this.state.company.des_company}}>
															</div>
														</div>
														<div className="row_box">
															<div className="row_box_left">
																Founded:
															</div>
															<div className="row_box_right">
																{this.state.company.founded_company}
															</div>
														</div>
														<div className="row_box">
															<div className="row_box_left">
																Employees:
															</div>
															<div className="row_box_right">
																{this.state.company.emp_company}
															</div>
														</div>
														<div className="row_box">
															<div className="row_box_left">
																Categories:
															</div>
															<div className="row_box_right">
																{this.state.company.cat_company}
															</div>
														</div>
														<div className="row_box">
															<div className="row_box_left">
																Website:
															</div>
															<div className="row_box_right">
																{this.state.company.web_company}
															</div>
														</div>
														<div className="row_box">
															<div className="row_box_left">
																Social:
															</div>
															<div className="row_box_right">
																{social}
															</div>
														</div>
													</div>
												</div>
											</section>
										</div>
                                        <div className="organization-outlet">
                                            <div className="org-grid__content-height-enforcer">
                                            <div className="display-flex justify-space-between full-width">
                                                <div className="org-grid__left-rail">
                                                    <section className="org-company-info-module__container artdeco-card">
                                                        <div className="feed_section mg0 pb3">
                                                            <div className="feed_top_box" style={{display: "block"}}>
                                                                <div className="feed_top_left company-avatar">
                                                                    {avatar_circle}
                                                                </div>
                                                                <div className="feed_top_right">
                                                                    <div className="feed_name user_name">
                                                                        <a href={"/company/"+this.state.company.id_company}>{this.state.company.name_company}</a>
                                                                        {follow_btn}
                                                                    </div>
                                                                    <div className="feed_user_major">
                                                                        {follow}<br/>
                                                                        {this.state.total} updates
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="feed_mid_box">
                                                                <div className="feed_content feed_company">
                                                                    Follow us to stay up to date with {this.state.company.name_company}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                                <div className="org-grid__core-rail">
                                                    <div className="feed-container-theme">
                                                        {this.state.feeds.length > 0 ?
                                                            <div className={"div-right"}>
                                                                <CoursePostsFeeds key="normal_feed" detail={1} user={0} courseId={0}
                                                                                  feeds={this.state.feeds}
                                                                                  handleFeedCallback={this.handleFeedCallback}/>
                                                            </div>:""
                                                        }
                                                        {this.state.load_done && this.state.total <= 0 ?
                                                            <div className="pv-profile-section pv-about-section artdeco-card p5 ember-view">
                                                                <div className="page_course_box_empty">
                                                                    We currently have no status updates.
                                                                </div>
                                                            </div>:""
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div>
                                            <Waypoint
                                                bottomOffset={-20}
                                                onEnter={this._handleWaypointEnter.bind(this)}
                                            />
                                        </div>
                                        {this.state.loading ? (<div className="center_div"><Loading type='spinningBubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>) : ""}
									</main>
									<aside className="scaffold-layout__aside">
										<div id="ember83" className="pv-deferred-area mt4 ember-view">
											<div className="pv-deferred-area__content">
												<div className="artdeco-card">
													<section className="pt5 pb3 ph4">
														<h2 className="text-heading-medium">
                                                            Contact Information
														</h2>
														<ul className="pv-profile-pymk__list">
                                                            <li className={"bor-bottom"}>
                                                                <p className="t-16 mt2">Website</p>
                                                                <div className={"txt"}>{this.state.company.web_company}&nbsp;</div>
                                                                <div className={"social mt2"}>{social}</div>
                                                            </li>

                                                            <li className={"circle mt2"}>
                                                                <div className="display-flex mt2">
                                                                    <img src="/static/img/appimg/icon_feed_flag.png"/>
                                                                    <p className="t-16">Flag this page for abuse</p>
                                                                </div>
                                                            </li>
														</ul>
													</section>
												</div>
											</div>
										</div>
									</aside>
								</div>
							</div>
						</main>
					</div>
				</div>
			</div>

                <POPUP style={customStyles2} show={this.state.showLoginPopover} onClose={this.onCloseLoginPopover.bind(this)} content={( <LoginPopup msg={"follow this company"} onClose={this.onCloseLoginPopover.bind(this)} />)} />
            </div>
        )
    }
}

CompanyPage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};
const mapStateToProps = function (store) {
    return {
        user: store.userState.user,
        socket: store.msgState.socket
    };
};

export default connect(mapStateToProps)(withRouter(CompanyPage));


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/company-detail.js
 **/